// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"0f8a64a7","762":"495a8e83"}[chunkId] + ".chunk.js";
};